import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/_services/auth.service';
import { UserProfile, UserProfileService } from 'src/app/_services/user-profile.service';


@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent implements OnInit {

  @Input() profile: UserProfile;
  @Output() profileChange = new EventEmitter<UserProfile>();

  @ViewChild('editProfileModalContent') private modalContent;

  private modal: NgbModalRef;
  protected previewImage: any;
  protected profileImage: File;
  protected errorMessage: string;
  protected submitting = false;

  constructor(
    private authService: AuthService,
    private userProfileService: UserProfileService,
    private modalService: NgbModal
  ) { }

  ngOnInit() {
    if (!this.profile) {
      this.userProfileService.getUserProfile(this.authService.currentUser.sub).then((profile) => {
        this.profile = profile;
        this.loadCurrentImage();
      });
    } else {
      this.loadCurrentImage();
    }
  }

  open() {
    this.errorMessage = null;
    this.modal = this.modalService.open(this.modalContent, { centered: true, windowClass: 'animated fadeInDown' });
  }

  close() {
    if (this.modal) {
      this.modal.close();
    }
  }

  private loadCurrentImage() {
    if (this.profile.relationships.field_imagen?.data?.id) {
      this.userProfileService.getUserImageURL(this.profile).then((url) => {
        this.profile.relationships.field_imagen.links.related.href = url;
        this.previewImage = url;
      });
    }
  }

  protected preview(event) {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.previewImage = e.target.result;
      this.profileImage = event.target.files[0];
    };
    reader.readAsDataURL(event.target.files[0]);
  }

  protected removeImage() {
    this.previewImage = null;
    this.profileImage = null;
  }

  protected onSubmit(form: NgForm) {
    this.submitting = true;

    if (form.valid) {

      // We need to create a new object to avoid sending non-editable fields that cause errors
      let sumbitData: UserProfile = {
        type: this.profile.type,
        id: this.profile.id,
        attributes: {
          field_nombre: this.profile.attributes.field_nombre,
          field_field_apellidos: this.profile.attributes.field_field_apellidos,
          field_entidad: this.profile.attributes.field_entidad,
          field_departamento: this.profile.attributes.field_departamento
        },
        relationships: {
          field_imagen: {
            data: this.profile.relationships.field_imagen.data,
            links: undefined
          }
        }
      };

      if (this.profileImage) {
        this.userProfileService.uploadUserImage(this.profile, this.profileImage).then((image) => {
          sumbitData.relationships.field_imagen.data = { id: image.id, type: image.type };
          this.userProfileService.updateUserProfile(sumbitData).then((profile) => {
            profile.relationships.field_imagen.links.related.href = image.url;
            this.profile = profile;
            this.profileChange.emit(profile);
            this.close();
            this.submitting = false;
          }).catch((error) => {
            this.errorMessage = error?.message;
            if (error?.message === 'Session expired. Please log in again.') {
              this.close();
              this.submitting = false;
            }
          });
        }).catch((error) => {
          this.errorMessage = error?.message;
          this.submitting = false;
        });
      } else {
        if (!this.previewImage) {
          sumbitData.relationships.field_imagen.data = null;
        }
        this.userProfileService.updateUserProfile(sumbitData).then((profile) => {
          if (profile.relationships?.field_imagen?.data && this.profile.relationships.field_imagen.links?.related)
            profile.relationships.field_imagen.links.related.href = this.profile.relationships.field_imagen.links.related.href;
          this.profile = profile;
          this.profileChange.emit(profile);
          this.close();
          this.submitting = false;
        }).catch((error) => {
          this.errorMessage = error?.message;
          this.submitting = false;
        });
      }
    } else {
      this.submitting = false;
    }
  }
}